// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__dY1QR","title":"style__title__9A7KB","menu":"style__menu__vmZuj","droppable":"style__droppable__wfnNy","buttonRight":"style__buttonRight__lrXov"};